/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { createAuth0Client, Auth0Client, Auth0ClientOptions, RedirectLoginOptions } from "@auth0/auth0-spa-js";
import { CONNECTION_TYPE, PROMPT_TYPE } from "enum/enums";

import { REACT_APP_AUTH0_AUDIENCE, REACT_APP_AUTH0_CLIENT_ID, REACT_APP_AUTH0_DOMAIN } from "lib/Constants";
console.log(REACT_APP_AUTH0_DOMAIN, "process.env.NEXT_PUBLIC_AUTH0_DOMAIN", REACT_APP_AUTH0_AUDIENCE);

const options: Auth0ClientOptions = {
	domain: REACT_APP_AUTH0_DOMAIN!, // your custom domain
	clientId: REACT_APP_AUTH0_CLIENT_ID!,
	authorizationParams: {
		redirect_uri: typeof window !== "undefined" ? `${window.location.origin}/auth/callback` : "",
		audience: REACT_APP_AUTH0_AUDIENCE!,
		scope: "openid profile email offline_access",
	},
	useRefreshTokens: true,
	cacheLocation: "localstorage", // to persist sessions across tabs and reloads
};

// Lazy singleton so we only create the client once
let clientPromise: Promise<Auth0Client> | null = null;
async function getClient(): Promise<Auth0Client> {
	if (!clientPromise) clientPromise = createAuth0Client(options);
	return clientPromise;
}

class Auth0Service {
	async handleRedirectCallback() {
		const client = await getClient();
		return client.handleRedirectCallback();
	}

	async getUser() {
		const client = await getClient();
		return client.getUser();
	}
	async loginWithRedirectOnly(redirectUri?: string) {
		const client = await getClient();
		return client.loginWithRedirect({
			authorizationParams: {
				...(redirectUri && { redirect_uri: redirectUri }),
			},
		});
	}
	async loginWithRedirect({
		email,
		inviteCode,
		promptType = PROMPT_TYPE.LOGIN,
		connection = CONNECTION_TYPE.EMAIL,
	}: {
		email: string;
		inviteCode?: string;
		promptType?: PROMPT_TYPE;
		connection?: CONNECTION_TYPE;
	}) {
		const client = await getClient();
		const state = { email, ...(inviteCode && { inviteCode }) };

		const opts: RedirectLoginOptions = {
			appState: state,
			authorizationParams: {
				connection,
				login_hint: email,
				prompt: promptType,
				scope: "openid profile email offline_access",
			},
		};

		return client.loginWithRedirect(opts);
	}

	async logout(returnTo?: string) {
		const client = await getClient();
		return client.logout({ logoutParams: { ...(returnTo && { returnTo }) } });
	}

	async isAuthenticated() {
		const client = await getClient();
		return client.isAuthenticated();
	}

	async silentLogin() {
		const client = await getClient();
		return client.getTokenSilently({
			authorizationParams: {
				scope: "openid profile email offline_access",
			},
			detailedResponse: true,
			timeoutInSeconds: 10,
		});
	}
}

export const auth0Service = new Auth0Service();
